import React from "react";
import InputArea from "../Components/form/input/InputArea";
import { useForm } from "react-hook-form";
import { notifySuccess } from "../utils/toast";
import { useNavigate } from "react-router-dom";
import useLogin from "../hooks/useLogin";
import Images from "../constant/Images";

const Login = () => {

  const { isLogin,
    setIsLogin,
    loading,
    setLoading,
    handleLogin,
    register,
    handleSubmit,
    errors,
    reset,
    handleResetToggle,
    handleManageLogin,
    visible
  } = useLogin()



  return (
    <div className="grid md:grid-cols-2 min-h-screen items-center">
      <div className="bg-gradient-to-b from-primary to-[#14362A] text-white text-center text-3xl font-bold h-full flex items-center justify-center">
      PKP Notify
      </div>

      <div className="px-10 md:px-36">
        <div className="absolute top-5 right-6">
          <img src={Images.clientLogo} className="w-16" />
        </div>
        <form onSubmit={handleSubmit(handleManageLogin)} className="space-y-4">

          <InputArea
            required={true}
            register={register}
            label="Email"
            name="email"
            type="email"
            placeholder="Enter your email"
            error={errors.email}
          />

       {!visible &&(
        <InputArea
            required={true}
            register={register}
            label="Password"
            name="password"
            type="password"
            placeholder="Enter your password"
            error={errors.password}
          />
       )}   

          <div onClick={handleResetToggle} className="text-blue-500 justify-end flex cursor-pointer">
         {!visible ? "Forgot password?" : "Back to login"}
          </div>

          <button
          disabled={loading}
          
            className={`w-full py-2 rounded-md ${loading ? "bg-slate-300" : "bg-primary"} text-white focus-within:none`}
            type="submit"
          >
            {!visible ? "Login" : "Reset Password"} 
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
